module.exports = __webpack_public_path__ + "static/media/keto360slim-1.ee752600.png";